﻿import SpeedcurveConversion from 'dataTransferObjects/speedcurveConversion';
import SpeedcurveMarkEnd from 'dataTransferObjects/speedcurveMarkEnd';
import SpeedcurveMarkStart from 'dataTransferObjects/speedcurveMarkStart';
import SpeedcurveTimingMetric from 'dataTransferObjects/speedcurveTimingMetric';
import SpeedcurveEventType from 'enums/speedcurveEvent';
import { markEnd, markStart, timingMetric, trackConversion } from 'middlewares/speedcurveRum';

/**
 * creates a track conversion using the provided name and value.
 */
const createTrackConversion = ({ name, value }) => trackConversion(() => new SpeedcurveConversion(name, value));

/**
 * creates a Speedcurve mark at the start of a track with the given name.
 */
const createTrackMarkStart = ({ name }) => markStart(() => new SpeedcurveMarkStart(name));

/**
 * creates a Speedcurve mark end based on the provided measure name, start mark name, and end mark name.
 */
const createTrackMarkEnd = ({ measureName, markNameStart, markNameEnd }) =>
  markEnd(() => new SpeedcurveMarkEnd(measureName, markNameStart, markNameEnd));

/**
 * creates a new Speedcurve timing metric with a specified name and value.
 */
const createTrackTiming = ({ name, value }) => timingMetric(() => new SpeedcurveTimingMetric(name, value));

/**
 * The getSpeedcurveEvent function returns a GoogleAdsEvent object.
 *
 */
const getSpeedcurveEvent = (eventType, events) => {
  if (eventType === SpeedcurveEventType.Conversion) {
    return events.map((event) => createTrackConversion(event));
  }

  if (eventType === SpeedcurveEventType.MarkStart) {
    return events.map((event) => createTrackMarkStart(event));
  }

  if (eventType === SpeedcurveEventType.MarkEnd) {
    return events.map((event) => createTrackMarkEnd(event));
  }

  if (eventType === SpeedcurveEventType.TimingMetric) {
    return events.map((event) => createTrackTiming(event));
  }

  return null;
};

export default getSpeedcurveEvent;
